import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTime0900Circle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeWidth: 1.5,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 6,
			r: 5.25
		}), /* @__PURE__ */ _jsx("path", { d: "M3.779 5.92h2.179V2.311m0 0Z" })]
	})
});
export { SvgTime0900Circle as ReactComponent };
